// extracted by mini-css-extract-plugin
module.exports = {"box":"toastify-message_box__31LTM","iconBox":"toastify-message_iconBox__3nt5F","message":"toastify-message_message__3uVWl"};